import React, {Component} from 'react';

import {Form, Row, Col, Button, Upload, Icon, Modal, message, Select , Spin ,Radio } from 'antd';

import reqwest from 'reqwest';

import ModalD from './../Modal';

import Input from './../Input';
import fetch from './../../services/fetch'
import CiqaFileCatetory from './ciqaFileCatetory'
import Multiple from './../../components/multiple';

const FormItem = Form.Item;
const Option = Select.Option;

class UploadModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            labelDatas:[],
            labelData:[],
            file: [],
            files: [],
            loading: false ,
            domain: {
                name: '',
                title : '',
                catetoryId: props.catetoryId,
                catetoryName : props.catetoryName,
                fileNumber:'',
                publishOrgId:'',
                publishDate: '',
                fileDesc:'',
                file: '',
                files: [],
                fileLabelId:[],
                fileType : 1 ,
                labelDatas:[],
                labelData:[],
                // labelData: props.labelData,
            }
        };

        this.domain = {
            name: '',
            title : '',
            catetoryId: props.catetoryId,
            catetoryName : props.catetoryName,
            fileNumber:'',
            publishOrgId:'',
            publishDate: '',
            fileDesc:'',
            file: '',
            files: [],
            fileLabelId:[],
            fileType : 1,
            labelDatas:[],
            labelData:[]
            // labelData: props.labelData
        }
    }

    handleSubmit() {

        event.preventDefault();
        this.props.form.validateFields((error, values) => {
            if(!error) {
                this.setState({
                    loading : true
                })
                const domain = this.domain;

                const formData = new FormData();
                formData.append('title', domain.title);
                formData.append('catetoryId', this.domain.catetoryId);
                formData.append('fileType', domain.fileType ? domain.fileType : 1);
                if(domain.labelDatas && domain.labelDatas.length > 0 ){
                    let fileLabelId = []
                    domain.labelDatas.map( label =>{
                        fileLabelId.push(label.key)
                    })
                    formData.append('fileLabelId', JSON.stringify(fileLabelId));
                }
                // formData.append('fileNumber', domain.fileNumber);
                // formData.append('publishOrgId', domain.publishOrgId);
                // formData.append('pubDate', moment(new Date(domain.publishDate)).format('YYYY-MM-DD'));
                // formData.append('fileDesc', domain.fileDesc);
                if(this.state.file && this.state.file.length == 1 ){

                    formData.append('firstFile', this.state.file[0]);
                }else{
                    Modal.error({
                        title : '提示',
                        content : '请选择主文件',
                        okText : '确定',
                        cancelText : '取消'
                    })
                    this.setState({
                        loading :false
                    })
                    return ;
                }

                this.state.files.forEach(file => {
                    formData.append('secondFile', file);
                });

                reqwest({
                    url: fetch.base + 'ciqafile/upload',
                    method: 'post',
                    processData: false,
                    data: formData,
                    crossOrigin: true, 
                    withCredentials: true,
                    success: (response) => {
                        this.setState({
                            file: [],
                            uploading: false,
                        });

                        var data = JSON.parse(response);

                        //const data = JSON.parse(response);
                        if(data.code === 200) {
                            Modal.success({
                                title: '文件上传',
                                content: '文件上传成功！',
                                onOk:() => {
                                    //this.props.form.setFieldsValue({publishDate: ''});
                                }
                            });
                        } else {
                            Modal.error({
                                title: '文件上传',
                                content: data.message,
                                onOk:() => {
                                    //this.props.form.setFieldsValue({publishDate: ''});
                                }
                            });
                        }
                        this.handleCancel();

                        this.domain = {
                            name: '',
                            catetoryId: this.props.catetoryId,
                            fileNumber:'',
                            publishOrgId:'',
                            publishDate: '',
                            fileDesc:'',
                            file: '',
                            files: []
                        };

                        this.setState({
                            loading : false,
                            file: [],
                            files: [],
                            domain: Object.assign({}, this.domain)
                        });



                        if(this.props.form) {
                            this.props.form.resetFields();
                        }
                    },
                    error: (response) => {
                        const data = JSON.parse(response);
                        this.setState({
                            uploading: false,
                        });
                        message.error(data.message);
                        this.handleCancel();

                        this.domain = {
                            name: '',
                            catetoryId: this.props.catetoryId,
                            fileNumber:'',
                            publishOrgId:'',
                            publishDate: '',
                            fileDesc:'',
                            file: '',
                            files: []
                        };

                        this.setState({
                            domain: Object.assign({}, this.domain)
                        });

                        if(this.props.form) {
                            this.props.form.resetFields();
                        }
                    },
                });
            }
        });
        
    }

    componentWillReceiveProps(nextProps) {
        const catetoryId = nextProps.catetoryId;
        if(catetoryId ) {
            this.domain = Object.assign({}, this.domain, {catetoryId});
        }
        
    }

    handleChange(data) {
        // if(!domain.catetoryId) {
            // const publishDate = new Date(data.publishDate).getTime();
            // const now = Date.now();

            // if(publishDate > now) {
            //     Modal.error({
            //         title: '日期选择错误',
            //         content: '发布日期大于当前日期！',
            //         onOk:() => {
            //             this.props.form.setFieldsValue({publishDate: ''});
            //         }
            //     });
            // } else {
            //     this.domain = Object.assign({}, this.domain, data);
            //     this.setState({
            //         domain: this.domain
            //     });
            // }
        // } else {
            let catetoryId = this.props.catetoryId
            this.domain = Object.assign({}, Object.assign({},this.state.domain , {catetoryId : catetoryId}) , data);
            this.setState({
                domain: this.domain
            });
        // }
        
    }
    
    handleCancel() {
        this.props.handleCancel();
    }

    onSubmit(event) {
        
    }

    onRemove(file) {
        this.setState({
            file: []
        });
    }

    onRemoves(file) {
        const files = this.state.files.filter(item => {
            return item.uid !== file.uid;
        });

        this.setState({
            files
        });
    }

    beforeUpload(file) {
        const size = file.size / ( 1024 * 1024 );
        if(size >= 100) {
            Modal.warn({
                title: '文件过大',
                content: <div>
                    请选择小于<span style={{color: 'red'}}>100m</span>的文件上传
                </div>,
                okText: '确认'
            })
            return;
        }
        this.setState(state => ({
            file: [file],
        }));
        return false;
    }

    beforeUploads(file) {
        const size = file.size / ( 1024 * 1024);
        if(size >= 100) {
            Modal.warn({
                title: '文件过大',
                content: <div>
                    请选择小于<span style={{color: 'red'}}>100m</span>的文件上传
                </div>,
                okText: '确认'
            })
            return;
        }
        this.setState(state => ({
            files: [...state.files, file],
        }));
        return false;
    }

    queryLabels(value) {
        fetch.post('/platform/code/ciqafilelabel',{})
        .then((response) => {
            let data =  response.payload.data
            return data.map(item => {
                return {
                    value: item.value,
                    key: item.value,
                    label: item.name
                }
            }).slice(0,50);
        }).then(labelData => {
            this.setState({
                domain : Object.assign({},this.domain , {
                    labelData : labelData
                })
            })
        });
    }

    render() {
        const file = this.state.file;
        const files = this.state.files;
        const props  = this.props;
        const {getFieldDecorator} = props.form;
        
        return (
            <ModalD title="上传文章" width="600px" visible={this.props.visible} okText={'发布文章'} handleSubmit={this.handleSubmit.bind(this)} handleCancel={this.handleCancel.bind(this)}>
               <Spin  tip="数据上传中..." spinning={this.state.loading}>
                <Form layout="inline"
                onSubmit={this.onSubmit.bind(this)}>
                    <div className="root-form-upload">
                        <Row>
                            <Col span="18"><Input name="title" label="文章标题" getFieldDecorator={getFieldDecorator} value={this.state.domain.title} handleChange={this.handleChange.bind(this)} /></Col>
                            <Col span="6"></Col>
                        </Row>
                        <Row>
                            <Col span="18">
                                <CiqaFileCatetory disabled={true} value={props.catetoryId} />
                                {/* <Input name="catetoryId" label="文章分类" getFieldDecorator={getFieldDecorator} 
                                disable={true} value={this.state.domain.catetoryName} handleChange={this.handleChange.bind(this)} />
                             */}
                                {/* <FormItem label="文章分类">
                                    <Select value = {this.state.domain.fileType } onChange={(value) => {
                                        const fileType = value
                                        this.handleChange({fileType})
                                    }} >
                                        <Option value={1}>游客可见</Option>
                                        <Option value={2}>盟员可见</Option>
                                    </Select>
                                </FormItem> */}
                            </Col>
                            <Col span="6"></Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <FormItem label="主文件上传">
                                {
                                    getFieldDecorator('file', {
                                        initialValue:  this.state.file||'',
                                        rules: [{
                                            required: true,
                                            message: '请选择文件上传',
                                        }],
                                    })(
                                        <Upload accept=".pdf" beforeUpload={this.beforeUpload.bind(this)} onRemove={(file) => {
                                            this.onRemove(file);
                                            }} fileList={file}>
                                            <Button style={{width:'180px'}}>
                                            <Icon type="upload"  />请选择主文件 
                                            </Button>
                                        </Upload>
                                    )
                                }
                                    
                                </FormItem>
                            </Col>
                            <Col span="0"></Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <FormItem label="附件上传">
                                <Upload beforeUpload={this.beforeUploads.bind(this)} onRemove={(file) => {
                                    this.onRemoves(file);
                                    }} fileList={files}>
                                    <Button style={{width:'180px'}}>
                                    <Icon type="upload" />请选择附件
                                    </Button>
                                </Upload>
                                    
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            {/* <Col span="24">
                                <FormItem label="标签">
                                    <CheckboxGroup
                                        value={this.state.domain.fileLabelId}
                                        onChange={(value) => {
                                            const fileLabelId = value;
                                            this.handleChange({fileLabelId});
                                        }}
                                        >
                                            {
                                                props.labelData.map(label => {
                                                  return  <Checkbox style={{width:'100px'}} value={label.value}> {label.name}</Checkbox>
                                                }) 
                                            }
                                    </CheckboxGroup>
                                </FormItem>
                            </Col> */}

                            <Col span={24}>
                                <Multiple
                                value={this.state.domain.labelDatas ? this.state.domain.labelDatas: []}
                                style={{width: 240}} 
                                name="fileLabelId"
                                search={true}
                                onChange={(labelDatas) => {
                                    this.handleChange({labelDatas})
                                }} 
                                onSearch={(value) => {
                                    this.queryLabels(value);
                                }}
                                onFocus={() => {
                                    this.queryLabels('');
                                }}
                                label="请选择标签"
                                placeholder="请选择标签"
                                data={this.state.domain.labelData ? this.state.domain.labelData: []} 
                                />
                            </Col>
                        </Row> 
                        <Row>
                            <Col span="18">
                                <FormItem label="文章类型" >
                                    <Radio.Group value = {this.state.domain.fileType ? this.state.domain.fileType : 1 } onChange={(event) => {
                                        const fileType = event.target.value
                                        this.handleChange({fileType})
                                    }} >
                                        <Radio  value={1}>游客可见</Radio >
                                        <Radio  value={2}>盟员可见</Radio >
                                    </Radio.Group>
                                </FormItem>
                            </Col>
                            <Col span="6"></Col>
                        </Row> 
                    </div>
                </Form>
                </Spin>
            </ModalD>
        )
    }
}

export default Form.create()(UploadModal);